// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1638283804884
      var cssReload = require("/Users/geras/Documents/electros/magic-electros-crm/vue-app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"reloadAll":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  